require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/00b853dcb41c779afdcc105ef59fa241/code.js', () => { 

BackendlessUI.Functions.Custom['fn_00b853dcb41c779afdcc105ef59fa241'] = async function fn_00b853dcb41c779afdcc105ef59fa241() {
var vReturn;


  vReturn = ({ [`sms_balance`]: (await BackendlessUI.Functions.Custom['fn_449e5c08b074bfa98c39b2b63f75661e']('balance', null)) });

return vReturn
}

})
define('./functions/1061783fb0d2269f4279d97ae4584ade/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1061783fb0d2269f4279d97ae4584ade'] = async function fn_1061783fb0d2269f4279d97ae4584ade(error, subject, process_step, data) {
var error, error_object, error_email, error_uuid;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  error_uuid = (generateUUID().short());
  error_email = 'it@schipholtravel.com';
  error_object = ({ 'error_page': [subject,' [',error_uuid,']'].join(''),'error_function': process_step,'error_message': [error].join(','),'error_data': (JSON.stringify(data)),'error_uuid': error_uuid });
  try {
    await Backendless.Data.of('errors').save( ({ 'error_id': error_uuid,'data': error_object,'environment': 6 }) );

  } catch (error) {
    console.log(error);

  } finally {
    try {
      await Backendless.Messaging.sendEmailFromTemplate('error general', Backendless.EmailEnvelope.create({ addresses: error_email, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), error_object, undefined);

    } catch (error) {
      console.log(error);

    }

  }

return 
}

})
define('./functions/1d01d2f674fd2d739b05fcacc26d2c09/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1d01d2f674fd2d739b05fcacc26d2c09'] = async function fn_1d01d2f674fd2d739b05fcacc26d2c09(search_type, search_string, data_object) {
var vReturn, j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  // 1 = stations
  if (search_type == 1) {
    vReturn = [];
    for (var j_index in data_object) {
      j = data_object[j_index];
      if (((JSON.stringify(j)).toUpperCase()).indexOf(search_string) !== -1) {
        if ((getObjectProperty(j, 'P')) == 1) {
          addItemToList(vReturn, j);
        }
      }
    }
    vReturn = (await asyncListSort(vReturn, 1, async (item) => {


     return (getObjectProperty(item, 'CIC'));
    }));
    vReturn = vReturn.slice(0, 10);
    for (var j_index2 in vReturn) {
      j = vReturn[j_index2];
      j['FullText'] = ([(getObjectProperty(j, 'CIN')),' - ',(getObjectProperty(j, 'N')),' (',(getObjectProperty(j, 'MC')),'), ',(getObjectProperty(j, 'CON'))].join(''));
      j['SelectText'] = ([(getObjectProperty(j, 'N')),' (',(getObjectProperty(j, 'MC')),')'].join(''));
    }
  }

return vReturn
}

})
define('./functions/449e5c08b074bfa98c39b2b63f75661e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_449e5c08b074bfa98c39b2b63f75661e'] = async function fn_449e5c08b074bfa98c39b2b63f75661e(type, api_body) {
var vAPI_headers, vAPI_method, vAPI_response, vAPI_url;


  vAPI_headers = ({ [`X-Client-Id`]: '332432357969415818694',[`X-Client-Secret`]: '9hrUzyyudbnut4cEZYd4T',[`Content-Type`]: 'application/json' });
  if (type == 'send') {
    vAPI_url = 'https://api.smsgatewayapi.com/v1/message/send';
    vAPI_method = 'post';
  }
  if (type == 'balance') {
    vAPI_url = 'https://api.smsgatewayapi.com/v1/balance';
    vAPI_method = 'get';
  }
  if (type == 'users') {
    vAPI_url = 'https://api.smsgatewayapi.com/v1/contact?limit=2000';
    vAPI_method = 'get';
  }
  if (type == 'sso') {
    vAPI_headers = ({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' });
    vAPI_url = 'https://airmessage.schipholtravel.com/api/smsgatewayapi/sso';
    vAPI_method = 'get';
  }
  vAPI_response = (await Backendless.Request[vAPI_method]((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(vAPI_url)).set(vAPI_headers).setEncoding('utf8').send(api_body));
  console.log(vAPI_response);

return vAPI_response
}

})
define('./functions/66456c1bfba92f950d9aac0f74875cd1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_66456c1bfba92f950d9aac0f74875cd1'] = async function fn_66456c1bfba92f950d9aac0f74875cd1(status, data_new) {
var vData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(data_new);
  console.log({ [`status`]: status,[`count`]: (getObjectProperty(data_new, 'count')),[`message`]: (getObjectProperty(data_new, 'message')),[`sendlist`]: (getObjectProperty(data_new, 'sendlist')),[`subject`]: (getObjectProperty(data_new, 'subject')),[`type`]: 1 });
  if (true) {
    if (!(await Backendless.UserService.isValidLogin())) {
      await Backendless.UserService.loginAsGuest(true);
    }
    await Backendless.Data.of('sms').save( ({ [`status`]: status,[`count`]: (getObjectProperty(data_new, 'count')),[`message`]: (getObjectProperty(data_new, 'message')),[`sendlist`]: (getObjectProperty(data_new, 'sendlist')),[`subject`]: (getObjectProperty(data_new, 'subject')),[`type`]: 1 }) );
  }

return vData
}

})
define('./functions/66f23f8b74f826164fad7e449cd6a636/code.js', () => { 

BackendlessUI.Functions.Custom['fn_66f23f8b74f826164fad7e449cd6a636'] = function fn_66f23f8b74f826164fad7e449cd6a636(profile_data) {
return 
}

})
define('./functions/6c4877a9f017f70b7e61ae0cccd105fb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6c4877a9f017f70b7e61ae0cccd105fb'] = function fn_6c4877a9f017f70b7e61ae0cccd105fb(type) {
var vSettings, vType_visibility, vType_disable;


  if (type == 1) {
    vType_disable = false;
    vType_visibility = true;
  } else {
    vType_disable = true;
    vType_visibility = false;
  }
  vSettings = ({ [`disable`]: vType_disable,[`visibility`]: vType_visibility });

return vSettings
}

})
define('./functions/9c575a65deb8c8cf33a9c82b4d070b66/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9c575a65deb8c8cf33a9c82b4d070b66'] = async function fn_9c575a65deb8c8cf33a9c82b4d070b66() {
var vdata_return, j, vdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vdata = (await BackendlessUI.Functions.Custom['fn_449e5c08b074bfa98c39b2b63f75661e']('users', null));
  vdata = (getObjectProperty(vdata, 'contacts'));
  vdata_return = [];
  for (var j_index in vdata) {
    j = vdata[j_index];
    addItemToList(vdata_return, ({ [`ID`]: (getObjectProperty(j, 'ID')),[`ConcernID`]: (getObjectProperty(j, 'extra1')),[`Organisatie`]: (getObjectProperty(j, 'extra2')),[`type`]: (getObjectProperty(j, 'extra3')) == 0 ? 'Intern' : 'Extern',[`TelefoonNummer`]: (getObjectProperty(j, 'phone')),[`Naam`]: [(getObjectProperty(j, 'firstname')),' ',(getObjectProperty(j, 'lastname'))].join('') }));
  }

return vdata_return
}

})
define('./functions/c05bfdb683bc50798692ce44aeaf2892/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c05bfdb683bc50798692ce44aeaf2892'] = function fn_c05bfdb683bc50798692ce44aeaf2892(Email) {
var vEmailIsSTI, j, List_STI_Domain;


  vEmailIsSTI = false;
  List_STI_Domain = ['@SCHIPHOLTRAVEL.COM', '@SWISSDATATECHNOLOGIES.COM'];
  for (var j_index in List_STI_Domain) {
    j = List_STI_Domain[j_index];
    if (Email.toUpperCase().indexOf(j) + 1 > 0) {
      vEmailIsSTI = true;
      break;
    }
  }

return vEmailIsSTI
}

})
define('./functions/dffa1f2478eb2e980d22c9b32492d3f7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'] = async function fn_dffa1f2478eb2e980d22c9b32492d3f7(type, data) {
var vList_sorted, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  // 1 = ontvangers
  if (type == 1) {
    vList_sorted = (await asyncListSort(data, 1, async (item) => {


     return ([(getObjectProperty(item, 'Organisatie')),(getObjectProperty(item, 'type')),(getObjectProperty(item, 'Naam'))].join('').toUpperCase());
    }));
  }
  // 2 = concerns
  if (type == 2) {
    vList_sorted = (await asyncListSort(data, 1, async (item) => {


     return ((getObjectProperty(item, 'label')).toUpperCase());
    }));
  }

return vList_sorted
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/FlightLookup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var vReferer, return2;


  vReferer = (await (async function() {
  	return document.referrer;
  })());
  return2 = (await Backendless.Data.of('Log').save( ({ [`LogType`]: 7,[`Ref1`]: vReferer,[`Comment`]: undefined,[`ip`]: undefined,[`Environment`]: 13 }) ));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/app_delete_account/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    var trf_id;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  trf_id = (getObjectProperty(___arguments.context.pageData, 'id'));
  if (trf_id == 'C2BBFB78-949D-4F86-97DC-91C6344CEB3D') {
    ___arguments.context.pageData['settings'] = ({ [`visible`]: true });
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/app_delete_account/components/a6bfa238fd9b8fe4769df95f6ec40bd5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var api_key, email_body, email_replyto, email_subject, vEmailCC2, vEmailTo2, vIdentifier, vResult, error;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('55cc92cb2c83eaed687ee2986cfd8527');
  vIdentifier = 'JURIJKRASAVINS@GMAIL.COM_TEST_NW_P';
  try {
    vResult = (await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/mtrip/traveller')).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send(({ [`identifier`]: vIdentifier })));

  } catch (error) {
    console.log(error);

  } finally {
    await Backendless.Data.of('message_queue_2').save( ({ [`type`]: 1,[`subject`]: String('App - account deletion: ') + String(vIdentifier),[`body`]: ['<p>Mtrip app account is verwijderd: ',vIdentifier,'</p><p>Result Mtrip API:<br>',(JSON.stringify(vResult)),'</p>'].join(''),[`to`]: ['it@schipholtravel.com'],[`cc`]: [],[`bcc`]: [],[`replyTo`]: 'rick.ruiter@schipholtravel.com',[`test`]: false,[`type_email_api_id`]: 'app_sign_up' }) );

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/app_signup/components/b75fe5e97a253c2b9781ccc9ec8e65e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, company, lastname, firstname, vError;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5002d6493a98690953bd2feb56698a1c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d03530fca82b102d3fb1385e30ac329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd1e6dedc7468ec61616c53994b7edb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e225978ba22763d1dc71aefd922b38be', false);
  vError = 0;
  console.log((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4c7203ff3e9912ed0a7c5558428bac4e'));
  firstname = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c7203ff3e9912ed0a7c5558428bac4e'), 'firstname'));
  lastname = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c7203ff3e9912ed0a7c5558428bac4e'), 'lastname'));
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c7203ff3e9912ed0a7c5558428bac4e'), 'email'));
  company = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c7203ff3e9912ed0a7c5558428bac4e'), 'company'));
  if (!firstname || getValueLength(firstname.trim()) == 0) {
    vError = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5002d6493a98690953bd2feb56698a1c', true);
  }
  if (!lastname || getValueLength(lastname.trim()) == 0) {
    vError = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d03530fca82b102d3fb1385e30ac329', true);
  }
  if (!email || getValueLength(email.trim()) == 0) {
    vError = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3dd1e6dedc7468ec61616c53994b7edb', true);
  }
  if (!company || getValueLength(company.trim()) == 0) {
    vError = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e225978ba22763d1dc71aefd922b38be', true);
  }
  if (vError == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c7203ff3e9912ed0a7c5558428bac4e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573f0db8f335df7b036c13ee3f2fa154', true);
    console.log('Send email');
    console.log((await Backendless.Request.post(`${Backendless.appPath}/services/email/send`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'type': 'app_sign_up','to': ['it@schipholtravel.com'],'replyTo': 'it@schipholtravel.com','htmlContent': (['<table class="Table" style="width:100.0%">','<tbody><tr>','<td colspan="2" style="width:100%">','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">','De volgende persoon heeft zich aangemeld:','</span></span></span></p>','</td></tr><tr><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">','Naam','</span></span></span></p>','</td><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">',[firstname,' ',lastname].join(''),'</span></span></span></p>','</td></tr><tr><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">','Bedrijf','</span></span></span></p>','</td><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">',company,'</span></span></span></p>','</td></tr><tr><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">','Email','</span></span></span></p>','</td><td>','<p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="font-family:&quot;Arial&quot;,sans-serif">',email,'</span></span></span></p>','</td></tr>','</tbody></table>','',''].join('')),'subject': (String('Nieuwe aanmelding voor de app - ') + String(email)),'tags': ['app_sign_up'] })));
  } else {
    console.log('no');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/emission-calculator/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var vStations, vDataLoad, vUserInfo, vReferer, log;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  vReferer = (await (async function() {
  	return document.referrer;
  })());
  vDataLoad = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  ___arguments.context.pageData['result'] = [];
  await ( async () => {
    const _uow = vDataLoad;

    if (true) {
      vStations = (_uow.find('data_process_queue', Backendless.DataQueryBuilder.create().setWhereClause('process_type = 1').setProperties('data_object').setPageSize(1)).setOpResultId('get_stations'));
      log = (_uow.create('Log', ({ [`LogType`]: 7,[`Ref1`]: vReferer,[`Comment`]: undefined,[`ip`]: undefined,[`Environment`]: 14 })).setOpResultId('save_log'));
    }

  })();

  await Backendless.UserService.loginAsGuest(false);
  await vDataLoad.execute();
  await Backendless.UserService.logout();
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('e4b8f121021f66ea843880eb3c2353bc', ({ [`stations`]: (getObjectProperty((getObjectProperty((getObjectProperty(vStations, 'result')), '0')), 'data_object')) }));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/emission-calculator/components/920b700ee82502ebdcfe8ebc2ee2466c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vResult, segments;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'boardpoint')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'offpoint')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'pax')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'class'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c48e960dbbc54653355c9048664c3af3', true);
    segments = [];
    addItemToList(segments, ({ [`IataDepartureCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'boardpoint')),[`IataDestinationCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'offpoint')),[`pax`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'pax')),[`FlightClass`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'class')),[`IataAirlineCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'airline')),[`IataEquipmentCode`]: null }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'retour')) == '1') {
      addItemToList(segments, ({ [`IataDepartureCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'offpoint')),[`IataDestinationCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'boardpoint')),[`pax`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'pax')),[`FlightClass`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'class')),[`IataAirlineCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c3c6930cd1cc62aedf94d82e71d6b02d'), 'airline')),[`IataEquipmentCode`]: null }));
    }
    vResult = (await Backendless.Request.post(`${Backendless.appPath}/services/emission_calculator/calculate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(segments)));
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('430bbc87384bb3b9d65ef15c0a812716')), (getObjectProperty(vResult, 'flightEmissions')));
  }
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/emission-calculator/components/3a5166f325a4c45b484c1b64e3b5545b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c48e960dbbc54653355c9048664c3af3'), 'result')) ? String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c48e960dbbc54653355c9048664c3af3'), 'result')), 'totalCo2Emissions')) + String(' tonnes') : 'Calculating ....')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/emission-calculator/components/0b6dbe2e28a79e8a77d2cb2a4078f1fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['result'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c48e960dbbc54653355c9048664c3af3', false);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c3c6930cd1cc62aedf94d82e71d6b02d', ({ 'class': 'Y','retour': '1' }));
  console.log((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c3c6930cd1cc62aedf94d82e71d6b02d'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/emission-calculator/components/e3d6c3f73a420087a5e425e178b22f6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}



  ;(function() {
    const callback = async () => {
        if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'boardpoint')) {
      delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint'];
    }
    if (___arguments.value.length > 1) {
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['search_station_type'] = 'BP';
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('732961e8a12e9dde543fcdffafc42e84', (await BackendlessUI.Functions.Custom['fn_1d01d2f674fd2d739b05fcacc26d2c09'](1, (___arguments.value.toUpperCase()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'stations')))));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('732961e8a12e9dde543fcdffafc42e84', true);
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('732961e8a12e9dde543fcdffafc42e84', []);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('732961e8a12e9dde543fcdffafc42e84', false);
    }

    };

    const timerId = 'station_search';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/emission-calculator/components/0ef1fe29c1ec036f323db4fc9f734487/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'MC')) != 0) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'search_station_type')) == 'BP') {
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint'] = ___arguments.context.dataModel;
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint_text'] = (getObjectProperty(___arguments.context.dataModel, 'SelectText'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'search_station_type')) == 'OP') {
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint'] = ___arguments.context.dataModel;
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint_text'] = (getObjectProperty(___arguments.context.dataModel, 'SelectText'));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('732961e8a12e9dde543fcdffafc42e84', null);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('732961e8a12e9dde543fcdffafc42e84', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/emission-calculator/components/84de984204afb36db686777d0117c425/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}



  ;(function() {
    const callback = async () => {
        if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'offpoint')) {
      delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint'];
    }
    if (___arguments.value.length > 1) {
      ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['search_station_type'] = 'OP';
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('732961e8a12e9dde543fcdffafc42e84', (await BackendlessUI.Functions.Custom['fn_1d01d2f674fd2d739b05fcacc26d2c09'](1, (___arguments.value.toUpperCase()), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'stations')))));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('732961e8a12e9dde543fcdffafc42e84', true);
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('732961e8a12e9dde543fcdffafc42e84', []);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('732961e8a12e9dde543fcdffafc42e84', false);
    }

    };

    const timerId = 'station_search';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/emission-calculator/components/913b4e574aa3a3b8128f8c2caea968db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var vBP, vOP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  vBP = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'boardpoint'));
  vOP = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'offpoint'));
  delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint'];
  delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint_text'];
  delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint'];
  delete ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint_text'];
  if (vOP) {
    ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint'] = vOP;
    ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['boardpoint_text'] = (getObjectProperty(vOP, 'SelectText'));
  }
  if (vBP) {
    ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint'] = vBP;
    ___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc')['offpoint_text'] = (getObjectProperty(vBP, 'SelectText'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/emission-calculator/components/f376991c7549e7b26a64b21e246e91c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vResult, segments;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'boardpoint')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'offpoint')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'pax')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'class'))) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c48e960dbbc54653355c9048664c3af3', null);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c48e960dbbc54653355c9048664c3af3', true);
    segments = [];
    addItemToList(segments, ({ [`IataDepartureCode`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'boardpoint')), 'MC')),[`IataDestinationCode`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'offpoint')), 'MC')),[`pax`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'pax')),[`FlightClass`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'class')),[`IataAirlineCode`]: '',[`IataEquipmentCode`]: '' }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'retour')) == 2) {
      addItemToList(segments, ({ [`IataDepartureCode`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'offpoint')), 'MC')),[`IataDestinationCode`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'boardpoint')), 'MC')),[`pax`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'pax')),[`FlightClass`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'class')),[`IataAirlineCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4b8f121021f66ea843880eb3c2353bc'), 'airline')),[`IataEquipmentCode`]: null }));
    }
    vResult = (await Backendless.Request.post(`${Backendless.appPath}/services/emission_calculator/calculate`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(segments)));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c48e960dbbc54653355c9048664c3af3', ({ [`result`]: vResult }));
    console.log(segments);
    console.log(vResult);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/file_upload/components/4f39765d1d174a87a50f70ea16579737/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
      await Backendless.UserService.loginAsGuest(false);

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      console.log(___arguments.error);
  if (await Backendless.UserService.isValidLogin()) {
    await Backendless.UserService.logout();
  }

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      if (await Backendless.UserService.isValidLogin()) {
    await Backendless.UserService.logout();
  }
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['file'] = ___arguments.uploadedFiles;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4f39765d1d174a87a50f70ea16579737');
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['upload_button'] = 'Replace file';

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.file['name_orig'] = (getObjectProperty(___arguments.file, 'name'));
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['file_orig'] = (getObjectProperty(___arguments.file, 'name'));

  return (getObjectProperty(___arguments.file, 'name'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/file_upload/components/2cc2435c39865b63b89a8c5a5f66f3de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, vHTML;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function data_check() {
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_name'))) {
    throw (new Error('Please fill in your name'))
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_email'))) {
    throw (new Error('Please fill in your email'))
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file'))) {
    throw (new Error('Please select a file to upload'))
  }
}


  try {
    await data_check();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', true);
    await Backendless.UserService.loginAsGuest(true);
    await Backendless.Data.of('data_uploads').save( ({ 'file_location': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file')),'name_original': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file_orig')),'person_name': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_name')),'person_email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_email')) }) );
    vHTML = ['<p>',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_name')),' heeft een nieuw bestand geupload.<br>','Email: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'person_email')),'<br>','Bericht: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'message')),'<br>','Origineel bestandsnaam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file_orig')),'<br>','Download: ','<a href="',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file')),'">link</a>','</p>'].join('');
    console.log((await Backendless.Request.post(`${Backendless.appPath}/services/email/send`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'type': 'file_upload','to': ['it@schipholtravel.com'],'cc': [],'bcc': [],'replyTo': 'it@schipholtravel.com','htmlContent': vHTML,'subject': 'New secure file upload','tags': ['file_upload'],'test': false })));
    if (await Backendless.UserService.isValidLogin()) {
      await Backendless.UserService.logout();
    }
    ___arguments.context.pageData['msg_status'] = 'File has been uploaded successfully!';
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4f39765d1d174a87a50f70ea16579737');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f91ed7cfeb5666f83b635e4a10e63318');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb1413139a4fe63411ac0c34f572e892', true);

  } catch (error) {
    console.log(error);
    (function (message) { alert(message) })(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/file_upload/components/f91ed7cfeb5666f83b635e4a10e63318/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['file_orig'] = 'No file selected';
  ___arguments.context.dataModel['upload_button'] = 'Select file';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/file_upload/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var vSTI, vReferer, vUploadData, vUploadFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  vReferer = (await (async function() {
  	return document.referrer;
  })());
  ___arguments.context.pageData['ref'] = vReferer;
  vSTI = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/get_user_info/get_ip2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://ipapi.co/json/')).setEncoding('utf8').send())))), 'isSTI'));
  vUploadFile = (getObjectProperty(___arguments.context.pageData, 'uploadfile'));
  if (vUploadFile) {
    await Backendless.UserService.loginAsGuest(true);
    vUploadData = (await Backendless.Data.of('data_uploads').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',vUploadFile,'\''].join(''))).setPageSize(1)));
    if ((getObjectProperty(vUploadData, 'length')) > 0) {
      await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((getObjectProperty((getObjectProperty(vUploadData, '0')), 'file_location')))).setEncoding('utf8').send();
      ___arguments.context.pageData['msg_status'] = 'File downloaded';
    } else {
      ___arguments.context.pageData['msg_status'] = 'No file found!';
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb1413139a4fe63411ac0c34f572e892', true);
    if (await Backendless.UserService.isValidLogin()) {
      await Backendless.UserService.logout();
    }
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', true);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/file_upload/components/76ce00ec839bb119cc54b93f39c9df7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb1413139a4fe63411ac0c34f572e892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f91ed7cfeb5666f83b635e4a10e63318', ({ 'upload_button': 'Select file','file_orig': 'No file selected' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, page_settings, profile_data, profile_key, uuid, profile_concern, j, concern_emergency;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function profile_view() {
  await Backendless.UserService.loginAsGuest(false);
  profile_data = (await Backendless.Data.of('profile_form').find(Backendless.DataQueryBuilder.create().setWhereClause((['uuid = \'',uuid,'\' AND ','objectId = \'',profile_key,'\''].join(''))).setPageSize(1)));
  await Backendless.UserService.logout();
  profile_data = (getObjectProperty((getObjectProperty(profile_data, '0')), 'data_object'));
  console.log(profile_data);
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('522d0a565a64f0c6ff057cd86bbcc702', (getObjectProperty(profile_data, 'corporate')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('d18dc759aa138548a0d237a2b947bcf2', (getObjectProperty(profile_data, 'personal')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('6a0b03b71cc229e6f09e0b13409bb3b3', (getObjectProperty(profile_data, 'air')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('6a0b03b71cc229e6f09e0b13409bb3b3')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('3527a101961a35eb2e835b3587af024d', (getObjectProperty(profile_data, 'membership')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3527a101961a35eb2e835b3587af024d')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('85fb5f09da157abfc9d59e3cc629c7c6', (getObjectProperty(profile_data, 'hotel')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85fb5f09da157abfc9d59e3cc629c7c6')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('2eb9732fcb7cfd39cf41b88a8661804c', (getObjectProperty(profile_data, 'car')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2eb9732fcb7cfd39cf41b88a8661804c')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('96dbf12709dc8352b48c2a72065109ac', (getObjectProperty(profile_data, 'additional')));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('96dbf12709dc8352b48c2a72065109ac')), ({ [`settings`]: page_settings }));

  } catch (error) {
    console.log(error);

  }
  try {
    if (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(profile_data, 'emergency')), 'list')), '0')), 'name')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('470581e33c84caeb875c6aaf3daa37d8', true);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('470581e33c84caeb875c6aaf3daa37d8', (getObjectProperty(profile_data, 'emergency')));
      Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('470581e33c84caeb875c6aaf3daa37d8')), ({ [`settings`]: page_settings }));
    }

  } catch (error) {
    console.log(error);

  }
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  uuid = (getObjectProperty(___arguments.context.pageData, 'uuid'));
  profile_key = (getObjectProperty(___arguments.context.pageData, 'key'));
  profile_concern = (getObjectProperty(___arguments.context.pageData, 'concern'));
  if (profile_concern) {
    concern_emergency = ['AMC', 'TEST'];
    for (var j_index in concern_emergency) {
      j = concern_emergency[j_index];
      if (j) {
        if (profile_concern.toUpperCase() == j) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('470581e33c84caeb875c6aaf3daa37d8', true);
          break;
        }
      }
    }
  }
  if (uuid && profile_key) {
    page_settings = (await BackendlessUI.Functions.Custom['fn_6c4877a9f017f70b7e61ae0cccd105fb'](0));
    ___arguments.context.pageData['settings'] = page_settings;
    await profile_view();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afc212c7a54e2347282f8c6e543726a2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ccbf31bd7dd93e31e8e4dd968a170b6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0dd0418411f67896ec5330dc941ac33', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2a5de5b71768389b9c6bb7ae229164c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6196a7bdeb18f93355325ce58d92983e', false);
  } else {
    ___arguments.context.pageData['uuid'] = (generateUUID().long());
    page_settings = (await BackendlessUI.Functions.Custom['fn_6c4877a9f017f70b7e61ae0cccd105fb'](1));
    ___arguments.context.pageData['settings'] = page_settings;
    if (profile_concern) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('522d0a565a64f0c6ff057cd86bbcc702', ({ [`company`]: profile_concern }));
    }
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3527a101961a35eb2e835b3587af024d')), ({ [`settings`]: page_settings }));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85fb5f09da157abfc9d59e3cc629c7c6')), ({ [`settings`]: page_settings }));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2eb9732fcb7cfd39cf41b88a8661804c')), ({ [`settings`]: page_settings }));
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('470581e33c84caeb875c6aaf3daa37d8')), ({ [`settings`]: page_settings }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23bbc1410a960e84adb8ca6ccf9ffd88', [({ [`propName`]: 0 }), ({ [`propName`]: 0 }), ({ [`propName`]: 0 })]);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6e76b195e65e7d565838d3dc26f8f74c', [({ [`propName`]: 0 }), ({ [`propName`]: 0 }), ({ [`propName`]: 0 })]);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7b47cc73d63d27e4bf4234bfb9df961', [({ [`propName`]: 0 }), ({ [`propName`]: 0 }), ({ [`propName`]: 0 })]);
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9df6e0b755d6686a9d9b122f3cb929ee', [({ [`propName`]: 0 })]);

    } catch (error) {
      console.log(error);

    }
  }
  console.log(___arguments.context.pageData);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/profileform/components/7ccbf31bd7dd93e31e8e4dd968a170b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3527a101961a35eb2e835b3587af024d'), 'mileage')), ({ 'propName': undefined }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/c0dd0418411f67896ec5330dc941ac33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85fb5f09da157abfc9d59e3cc629c7c6'), 'list')), ({ [`propName`]: undefined }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/b2a5de5b71768389b9c6bb7ae229164c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2eb9732fcb7cfd39cf41b88a8661804c'), 'list')), ({ [`propName`]: undefined }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/afc212c7a54e2347282f8c6e543726a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vError_alert, vError, error, vData, email_end, email_profile_info, email_intro, emailcc, profile_url, profile_key, j, auto_email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function check() {
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')).trim()) == 0) {
    vError = 1;
    vError_alert = 'Please enter your company';
    return ;
  }
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email')).trim()) == 0) {
    vError = 1;
    vError_alert = 'Please enter a business email address';
    return ;
  }
  // Valid email
  if (!(await Backendless.Request.get(`${Backendless.appPath}/services/general/email_validate`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'email': JSON.stringify((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email'))) }).send())) {
    vError = 1;
    vError_alert = 'Please enter a valid business email address';
    return ;
  }
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')).trim()) == 0) {
    vError = 1;
    vError_alert = 'Please enter your first name (as in passport)';
    return ;
  }
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')).trim()) == 0) {
    vError = 1;
    vError_alert = 'Please enter your last name (as in passport)';
    return ;
  }
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'gender'))) {
    vError = 1;
    vError_alert = 'Please select your gender';
    return ;
  }
  // email
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'dob_day')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'dob_month')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'dob_year'))) {
    vError = 1;
    vError_alert = 'Please enter your date of birth';
    return ;
  }
  // mobile phone
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'phonemobile')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'phonemobile')).trim()) == 0) {
    vError = 1;
    vError_alert = 'Please enter your mobile phone number';
    return ;
  }
  // Wanneer pasport 1 is ingevuld, dan moeten
  // nationality en exp date ook ingevuld zijn
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr1')) && getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr1')).trim()) > 1) {
    // nationality
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'nationality')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'nationality')).trim()) == 0) {
      vError = 1;
      vError_alert = 'Please enter your nationality';
      return ;
    }
    // passport expiry 1
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_day')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_month')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_year'))) {
      vError = 1;
      vError_alert = 'Please enter the passport expiry date';
      return ;
    }
  }
  // Wanneer pasport exp 1 is ingevuld, dan moeten
  // nationality en number ook ingevuld zijn
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_day')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_month')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp1_year'))) {
    // passport number 1
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr1')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr1')).trim()) == 0) {
      vError = 1;
      vError_alert = 'Please enter the passport number';
      return ;
    }
  }
  // Wanneer pasport 2 is ingevuld, dan moeten
  // nationality en exp date ook ingevuld zijn
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr2')) && getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr2')).trim()) > 1) {
    // nationality
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'nationality')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'nationality')).trim()) == 0) {
      vError = 1;
      vError_alert = 'Please enter your nationality';
      return ;
    }
    // passport expiry 2
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_day')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_month')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_year'))) {
      vError = 1;
      vError_alert = 'Please enter the passport expiry date of your second passport';
      return ;
    }
  }
  // Wanneer pasport exp 2 is ingevuld, dan moeten
  // nationality en number ook ingevuld zijn
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_day')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_month')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportexp2_year'))) {
    // passport number 2
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr2')) || getValueLength((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'passportnbr2')).trim()) == 0) {
      vError = 1;
      vError_alert = 'Please enter the passport number of your second passport';
      return ;
    }
  }
}

/**
 * Describe this function...
 */
async function email_cc() {
  auto_email = [({ [`concern`]: 'AMC',[`email`]: 'AmsterdamUMC@Schipholtravel.com' }), ({ [`concern`]: 'TEST',[`email`]: 'rick.ruiter@Schipholtravel.com' }), ({ [`concern`]: 'MEDIAMONKS',[`email`]: 'mediamonks@schipholtravel.com' }), ({ [`concern`]: 'MEDIA.MONKS',[`email`]: 'mediamonks@schipholtravel.com' }), ({ [`concern`]: 'EUROSORT',[`email`]: 'Rolf.Botter@schipholtravel.com' }), ({ [`concern`]: 'HOLLAND CASINO',[`email`]: 'Hollandcasino@schipholtravel.com' }), ({ [`concern`]: 'DELTARES',[`email`]: 'deltares@schipholtravel.com' })];
  for (var j_index in auto_email) {
    j = auto_email[j_index];
    if (j) {
      if ((getObjectProperty(j, 'concern')).trim().toUpperCase() == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')).trim().toUpperCase()) {
        emailcc = (getObjectProperty(j, 'email'));
        break;
      }
    }
  }
  if (!emailcc) {
    emailcc = 'info@schipholtravel.com';
  }
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afc212c7a54e2347282f8c6e543726a2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('701ad73db1b83a959156282d068e57e3', true);
    vError = 0;
    vData = ({ [`corporate`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')),[`personal`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')),[`air`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('6a0b03b71cc229e6f09e0b13409bb3b3')),[`membership`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3527a101961a35eb2e835b3587af024d')),[`hotel`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85fb5f09da157abfc9d59e3cc629c7c6')),[`car`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2eb9732fcb7cfd39cf41b88a8661804c')),[`additional`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('96dbf12709dc8352b48c2a72065109ac')),[`emergency`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('470581e33c84caeb875c6aaf3daa37d8')) });
    console.log(vData);
    await check();
    if (vError == 1) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afc212c7a54e2347282f8c6e543726a2', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('701ad73db1b83a959156282d068e57e3', false);
      ___arguments.context.pageData['err'] = ({ [`error_page`]: 'Error occurred',[`error_message`]: vError_alert });
      await BackendlessUI.Functions.Custom['fn_1061783fb0d2269f4279d97ae4584ade'](vError_alert, 'Profile form - request not complete', 'Profile check', vData);
      (function (message) { alert(message) })(vError_alert);
    }
    if (vError == 0) {
      await Backendless.UserService.loginAsGuest(false);
      profile_key = (getObjectProperty((await Backendless.Data.of('profile_form').save( ({ [`uuid`]: (getObjectProperty(___arguments.context.pageData, 'uuid')),[`data_object`]: vData }) )), 'objectId'));
      profile_url = ['https://forms.schipholtravel.com/general/index.html?page=profileform','&uuid=',(getObjectProperty(___arguments.context.pageData, 'uuid')),'&key=',profile_key].join('');
      email_intro = ['<p>Dear ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')),' ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')),',</p>','<p>We have received your profile in good order.<br>','Please click <a href="',profile_url,'">here</a> to see your profile.</p>',''].join('');
      if (true) {
        email_profile_info = ['','<table border="0" style="border-collapse: collapse; width: 100%; height: 48.5312px; float: left;">','<tbody>','<tr style="height: 26.1406px;">','<td style="width: 13.1073%; height: 26.1406px;"><span style="font-size: 14pt;"><strong>Information</strong></span></td>','<td style="width: 86.8927%;"><span style="font-size: 14pt;"><strong>&nbsp;</strong></span></td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Company','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Gender','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'gender')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','First name','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Last name','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Email','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'</tbody>','</table>'].join('');
      }
      email_end = ['<p></p>','<p>Kind regards,</p>','','<p>Schiphol Travel International</p>'].join('');
      await email_cc();
      await Backendless.Data.of('message_queue_2').save( ({ [`type`]: 9,[`subject`]: ['Your STI traveller profile was created ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')).toUpperCase(),' | ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')).toUpperCase()].join(''),[`body`]: [email_intro,email_profile_info,email_end].join(''),[`to`]: [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email'))],[`cc`]: [],[`bcc`]: [emailcc, 'rick.ruiter@schipholtravel.com'],[`replyTo`]: emailcc,[`test`]: false,[`type_email_api_id`]: 'profile' }) );
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('626f48811924c197c9432ce253681e42', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcdf9327e966440b523ea60f26db90de', true);
    }
    if (await Backendless.UserService.isValidLogin()) {
      await Backendless.UserService.logout();
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_1061783fb0d2269f4279d97ae4584ade'](error, 'Profile form - unable to send request', 'Profile send/process', vData);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afc212c7a54e2347282f8c6e543726a2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('701ad73db1b83a959156282d068e57e3', false);
    ___arguments.context.pageData['err'] = ({ [`error_page`]: 'Error occurred',[`error_message`]: error });
    (function (message) { alert(message) })(vError_alert);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/00a7182471d3d20452cf2443d3f6ab18/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('00a7182471d3d20452cf2443d3f6ab18');

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/profileform/components/6196a7bdeb18f93355325ce58d92983e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('470581e33c84caeb875c6aaf3daa37d8'), 'list')), ({ [`propName`]: undefined }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profileform/components/85aa70addca7de9865b3e59375e6a732/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3527a101961a35eb2e835b3587af024d'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/cd1a8ad5773451c771fc920e11219756/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3527a101961a35eb2e835b3587af024d'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/20144256ab9c1637543ee153d645b431/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85fb5f09da157abfc9d59e3cc629c7c6'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/8de2f0a5d79e5b328f375b59104c969c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85fb5f09da157abfc9d59e3cc629c7c6'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/cef6b396e79b0a22a5fbc20683797c32/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2eb9732fcb7cfd39cf41b88a8661804c'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/abff14d53f82d25812bb95e99f314ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2eb9732fcb7cfd39cf41b88a8661804c'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/c5ae65d13d63b00b22a37485760fe3e2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('470581e33c84caeb875c6aaf3daa37d8'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/0313830d0c6e3c572405982599634068/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('470581e33c84caeb875c6aaf3daa37d8'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/a4378546a9b2bb0a415950760e269d0d/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('470581e33c84caeb875c6aaf3daa37d8'), 'settings')), 'disable'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/profileform/components/5d14c9fdaa085542240646f4069937e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, vError_alert, vData, email_end, email_profile_info, email_intro, emailcc, profile_url, profile_key, vError, j, auto_email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function email_cc() {
  auto_email = [({ [`concern`]: 'AMC',[`email`]: 'AmsterdamUMC@Schipholtravel.com' }), ({ [`concern`]: 'TEST',[`email`]: 'rick.ruiter@Schipholtravel.com' }), ({ [`concern`]: 'MEDIAMONKS',[`email`]: 'mediamonks@schipholtravel.com' })];
  for (var j_index in auto_email) {
    j = auto_email[j_index];
    if (j) {
      if ((getObjectProperty(j, 'concern')).trim().toUpperCase() == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')).trim().toUpperCase()) {
        emailcc = (getObjectProperty(j, 'email'));
        break;
      }
    }
  }
  if (!emailcc) {
    emailcc = 'info@schipholtravel.com';
  }
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d14c9fdaa085542240646f4069937e9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebdbbd93f5f2f415f812a5cd81f2ca0c', true);
    vError = 0;
    vData = ({ [`corporate`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')),[`personal`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')),[`air`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('6a0b03b71cc229e6f09e0b13409bb3b3')),[`membership`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3527a101961a35eb2e835b3587af024d')),[`hotel`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85fb5f09da157abfc9d59e3cc629c7c6')),[`car`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2eb9732fcb7cfd39cf41b88a8661804c')),[`additional`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('96dbf12709dc8352b48c2a72065109ac')),[`emergency`]: ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('470581e33c84caeb875c6aaf3daa37d8')) });
    if (vError == 0) {
      await Backendless.UserService.loginAsGuest(false);
      profile_key = (getObjectProperty(___arguments.context.pageData, 'key'));
      profile_url = ['https://forms.schipholtravel.com/general/index.html?page=profileform','&uuid=',(getObjectProperty(___arguments.context.pageData, 'uuid')),'&key=',profile_key].join('');
      email_intro = ['<p>Dear ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')),' ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')),',</p>','<p>We have received your profile in good order.<br>','Please click <a href="',profile_url,'">here</a> to see your profile.</p>',''].join('');
      if (true) {
        email_profile_info = ['','<table border="0" style="border-collapse: collapse; width: 100%; height: 48.5312px; float: left;">','<tbody>','<tr style="height: 26.1406px;">','<td style="width: 13.1073%; height: 26.1406px;"><span style="font-size: 14pt;"><strong>Information</strong></span></td>','<td style="width: 86.8927%;"><span style="font-size: 14pt;"><strong>&nbsp;</strong></span></td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Company','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Gender','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'gender')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','First name','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'firstname')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Last name','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'<tr style="height: 22.3906px;">','<td style="width: 13.1073%; height: 22.3906px;">','Email','</td>','<td style="width: 86.8927%;">',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email')),'</td>','</tr>'].join('');
        email_profile_info = [email_profile_info,'</tbody>','</table>'].join('');
      }
      email_end = ['<p></p>','<p>Kind regards,</p>','','<p>Schiphol Travel International</p>'].join('');
      await email_cc();
      await Backendless.Request.post(`${Backendless.appPath}/services/email/send`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'type': 'profile','to': [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'email'))],'cc': [],'bcc': [emailcc, 'rick.ruiter@schipholtravel.com'],'replyTo': emailcc,'htmlContent': ([email_intro,email_profile_info,email_end].join('')),'subject': (['Your STI traveller profile was created ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('522d0a565a64f0c6ff057cd86bbcc702')), 'company')).toUpperCase(),' | ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('d18dc759aa138548a0d237a2b947bcf2')), 'lastname')).toUpperCase()].join('')) });
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('626f48811924c197c9432ce253681e42', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcdf9327e966440b523ea60f26db90de', true);
    }
    if (await Backendless.UserService.isValidLogin()) {
      await Backendless.UserService.logout();
    }

  } catch (error) {
    console.log(error);
    await BackendlessUI.Functions.Custom['fn_1061783fb0d2269f4279d97ae4584ade'](error, 'Profile form - unable to send request', 'Profile send/process', vData);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d14c9fdaa085542240646f4069937e9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebdbbd93f5f2f415f812a5cd81f2ca0c', false);
    ___arguments.context.pageData['err'] = ({ [`error_page`]: 'Error occurred',[`error_message`]: error });
    (function (message) { alert(message) })(vError_alert);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var vConcerns2, vConcerns, vdata, item, j, ini_user, vUserInfo, user_info;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vUserInfo = ({ [`X-Forwarded-For`]: 'Unknown',[`X-Real-IP`]: 'Unknown',[`isSTI`]: 1 });
  if ((getObjectProperty(vUserInfo, 'isSTI')) == 1) {
    ___arguments.context.pageData['settings'] = ({ [`general_disabled`]: false,[`general_visible`]: true });
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5206282c5ccb4633d39aeefb01ff7ec8', true);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1ced5d2421b1236c10ea90ab70110a96', (await BackendlessUI.Functions.Custom['fn_00b853dcb41c779afdcc105ef59fa241']()));
    vdata = (await BackendlessUI.Functions.Custom['fn_9c575a65deb8c8cf33a9c82b4d070b66']());
    vConcerns = [];
    for (var j_index in vdata) {
      j = vdata[j_index];
      if (!(vConcerns.includes((getObjectProperty(j, 'Organisatie'))))) {
        addItemToList(vConcerns, (getObjectProperty(j, 'Organisatie')));
      }
    }
    vConcerns2 = (await Promise.all(vConcerns.map(async item => {; return ({ [`label`]: item,[`value`]: item });})));
    vConcerns = (await Promise.all(vConcerns.map(async item => {; return ({ [`key`]: item,[`data`]: item,[`label`]: item });})));
    vConcerns = (await BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'](2, vConcerns));
    vConcerns2 = (await BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'](2, vConcerns2));
    vdata = (await BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'](1, vdata));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('0062b56bd89d616ff334fb58a079062c', ({ [`Ontvangers`]: vdata,[`Concerns`]: vConcerns,[`Concerns2`]: vConcerns2 }));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/sms/components/1389de1ad4b9bbad2cb63cd6f8b79f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ced5d2421b1236c10ea90ab70110a96', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ddddbdf82ad09feed825ea7cd81f4c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77f1fb2a09a3a665577c27e94add357b', true);
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f2c7cba8b8be25b568c4188175dd569', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b615bfc2155ce5d33b8d467256d7364e', ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/4ee143d3a2c1c649999afc7affb1396a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ced5d2421b1236c10ea90ab70110a96', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77f1fb2a09a3a665577c27e94add357b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ddddbdf82ad09feed825ea7cd81f4c', true);
  console.log(___arguments.context.getComponentDataStoreByUid('0062b56bd89d616ff334fb58a079062c'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'general_visible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sms/components/589ae992affe73f964fc4a5667d48b7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error, vSendlist, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'subject'))) {
    (function (message) { alert(message) })('Voeg een onderwerp toe');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'subject'))) < 10) {
    (function (message) { alert(message) })('Onderwerp moet op zijn minst 10 karakters zijn');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'message'))) {
    (function (message) { alert(message) })('Voeg een bericht toe');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'message'))) < 10) {
    (function (message) { alert(message) })('Bericht moet op zijn minst 10 karakters zijn');
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'message'))) > 150) {
    (function (message) { alert(message) })('Message mag max 150 karakters hebben');
  } else {
    vSendlist = [];
    // Extern
    var j_list = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('8ef8dce7a9f30a8e3f4609a93becd409')), 'Ontvangers'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(vSendlist, j);
    }
    // Intern
    var j_list2 = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('736fb6ff1ea1b07a8ed39fb96833f6ca')), 'Ontvangers'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(vSendlist, j);
    }
    if (vSendlist.length == 0) {
      (function (message) { alert(message) })('Selecteer op zijn minst 1 contact');
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('154885f560136dba1a487cb31da94f84', true);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('154885f560136dba1a487cb31da94f84', ({ [`type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2e28397fdd938e5164a56cbbbad55673')), 'type')),[`subject`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2e28397fdd938e5164a56cbbbad55673')), 'subject')),[`message`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2e28397fdd938e5164a56cbbbad55673')), 'message')),[`sendlist`]: vSendlist,[`count`]: String('Totaal: ') + String(vSendlist.length) }));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e28397fdd938e5164a56cbbbad55673', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/44c8398a319c6d3af074dbe22e0f87e6/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('431b4a0671b9656e6365c34825ecab24'), 'Concerns'))

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var vOntvangers_intern, vOntvangers_extern, j, vOntvangers_intern_temp, vSelection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (false) {
    vOntvangers_extern = [];
    vOntvangers_intern = [];
    vOntvangers_intern_temp = [];
    var vSelection_list = ___arguments['selectedItems'];
    for (var vSelection_index in vSelection_list) {
      vSelection = vSelection_list[vSelection_index];
      var j_list = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('431b4a0671b9656e6365c34825ecab24')), 'Ontvangers'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(j, 'Organisatie')) == (getObjectProperty(vSelection, 'data'))) {
          if ((getObjectProperty(j, 'type')).toUpperCase() == 'INTERN') {
            if (!(vOntvangers_intern_temp.includes((getObjectProperty(j, 'Naam'))))) {
              addItemToList(vOntvangers_intern_temp, (getObjectProperty(j, 'Naam')));
              addItemToList(vOntvangers_intern, ({ [`Naam`]: (getObjectProperty(j, 'Naam')),[`TelefoonNummer`]: (getObjectProperty(j, 'TelefoonNummer')),[`Organisatie`]: 'STI' }));
            }
          } else {
            addItemToList(vOntvangers_extern, j);
          }
        }
      }
    }
    if (false) {
      addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Arlette van Bezu',[`EmailAdres`]: 'Arlette.van.Bezu@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '628646561',[`TelefoonNummerCompleet`]: '+31628646561',[`type`]: 'Intern' }));
      addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Daan Lenderink',[`EmailAdres`]: 'Daan.Lenderink@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '651490911',[`TelefoonNummerCompleet`]: '+31651490911',[`type`]: 'Intern' }));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fd7b26828a29134c5bcfd277935bc38', vOntvangers_extern);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8425bd5d7824babf57b629fc987111b', vOntvangers_intern);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sms/components/431b4a0671b9656e6365c34825ecab24/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  ['onContainerDataAssignment'](___arguments) {
      return ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c'))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/sms/components/f12c3a8477b2eeedcbb619693c757f43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b615bfc2155ce5d33b8d467256d7364e', null);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a84308d1f66890e831765df06dc7c08', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f12c3a8477b2eeedcbb619693c757f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f2c7cba8b8be25b568c4188175dd569', false);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'general_disabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sms/components/d382beca1323a1bba1af39e18ea1b997/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1a84308d1f66890e831765df06dc7c08', null);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f12c3a8477b2eeedcbb619693c757f43', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a84308d1f66890e831765df06dc7c08', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8013b3addab4e4427cb60b28668b7247', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b615bfc2155ce5d33b8d467256d7364e', ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f2c7cba8b8be25b568c4188175dd569', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8013b3addab4e4427cb60b28668b7247', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/909858629e9c0be7a82ddc5ad7e56ddd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vData_check, vError_Text, vUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function data_check() {
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'naam')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'naam')).trim().length == 0) {
    vError_Text = 'Vul een naam in';
    return ;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')).trim().length == 0) {
    vError_Text = 'Vul een organisatie in';
    return ;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')).trim().length == 0) {
    vError_Text = 'Selecteer een landcode voor het telefoonnummer';
    return ;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')).trim().length == 0) {
    vError_Text = 'Vul een telefoonnummer in';
    return ;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email')).trim().length == 0) {
    vError_Text = 'Vul een email adres in';
    return ;
  }
  if (!(await Backendless.Request.get(`${Backendless.appPath}/services/general/email_validate`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'email': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email'))) }).send())) {
    vError_Text = 'Vul een geldig email adres in';
    return ;
  }
  vData_check = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vData_check = false;
  await data_check();
  // Data is fout
  if (!vData_check) {
    (function (message) { alert(message) })(vError_Text);
  }
  // Data is ok
  if (vData_check) {
    vUser = ({ [`EmailAdres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email')),[`LandCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')),[`Naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'naam')),[`Organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')),[`TelefoonNummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')),[`TelefoonNummerCompleet`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')) });
    console.log((await BackendlessUI.Functions.Custom['fn_66456c1bfba92f950d9aac0f74875cd1'](vUser)));
    addItemToList((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')), 'Ontvangers')), ({ [`EmailAdres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email')),[`LandCode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')),[`Naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'naam')),[`Organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')),[`TelefoonNummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')),[`TelefoonNummerCompleet`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'landcode')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'nummer')),[`type`]: (await BackendlessUI.Functions.Custom['fn_c05bfdb683bc50798692ce44aeaf2892']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'email')))) ? 'Intern' : 'Extern' }));
    addItemToList((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')), 'Concerns')), ({ [`key`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')),[`label`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')),[`data`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1a84308d1f66890e831765df06dc7c08'), 'organisatie')) }));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c'))['Concerns'] = (await BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'](2, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')), 'Concerns'))));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c'))['Ontvangers'] = (await BackendlessUI.Functions.Custom['fn_dffa1f2478eb2e980d22c9b32492d3f7'](1, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')), 'Ontvangers'))));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1a84308d1f66890e831765df06dc7c08', null);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f12c3a8477b2eeedcbb619693c757f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a84308d1f66890e831765df06dc7c08', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8013b3addab4e4427cb60b28668b7247', true);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b615bfc2155ce5d33b8d467256d7364e', ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('0062b56bd89d616ff334fb58a079062c')));
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8013b3addab4e4427cb60b28668b7247', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f2c7cba8b8be25b568c4188175dd569', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/89f9348a9daae7ad2fa55e09934abc72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ddddbdf82ad09feed825ea7cd81f4c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77f1fb2a09a3a665577c27e94add357b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ced5d2421b1236c10ea90ab70110a96', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1ced5d2421b1236c10ea90ab70110a96', (await BackendlessUI.Functions.Custom['fn_00b853dcb41c779afdcc105ef59fa241']()));
  console.log((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('1ced5d2421b1236c10ea90ab70110a96'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/cf39c082f5338b2d8b635386af4dfcbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, vAPI_response_text, j, vAPI_response, vAPI_body, vAPI_headers, vTo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf39c082f5338b2d8b635386af4dfcbf', false);
    console.log(___arguments.context.getComponentDataStoreByUid('154885f560136dba1a487cb31da94f84'));
    vTo = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('154885f560136dba1a487cb31da94f84')), 'sendlist')).map(item => item['TelefoonNummer']));
    console.log(vTo);
    vAPI_body = ({ [`message`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('154885f560136dba1a487cb31da94f84')), 'message')),[`to`]: vTo,[`sender`]: 'SchphlTravl',[`reference`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('154885f560136dba1a487cb31da94f84')), 'subject')),[`test`]: 'false' });
    console.log(vAPI_body);
    vAPI_response = (await BackendlessUI.Functions.Custom['fn_449e5c08b074bfa98c39b2b63f75661e']('send', vAPI_body));
    console.log(vAPI_headers);
    console.log(vAPI_body);
    console.log(vAPI_response);
    vAPI_response_text = null;
    for (var j_index in vAPI_response) {
      j = vAPI_response[j_index];
      vAPI_response_text = String(vAPI_response_text) + String(j);
    }
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('94f57ed2ce2e42bda82e033c09c1515e', ({ [`response`]: vAPI_response_text }));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94f57ed2ce2e42bda82e033c09c1515e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65ceffcbc0f9a48b6ed267f431df5e6b', false);
    if (true) {
      if (!(await Backendless.UserService.isValidLogin())) {
        await Backendless.UserService.loginAsGuest(true);
      }
    }
    console.log((await BackendlessUI.Functions.Custom['fn_66456c1bfba92f950d9aac0f74875cd1'](2, ___arguments.context.getComponentDataStoreByUid('154885f560136dba1a487cb31da94f84'))));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/3d9ea0dc80e88ff25b8238138774906c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('154885f560136dba1a487cb31da94f84', null);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e28397fdd938e5164a56cbbbad55673', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('154885f560136dba1a487cb31da94f84', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/a6b5b347b87be84f679604c8344c9d7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['*** Read only modus active *** - User ',(getObjectProperty(___arguments.context.pageData, 'ini_user')),' is al ingelogd.',''].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sms/components/093e75ad61f2393bd78ec036271f15ef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var vContent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 100 || 0));
  vContent = ['Totaal contacten: ',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b615bfc2155ce5d33b8d467256d7364e')), 'Ontvangers')) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b615bfc2155ce5d33b8d467256d7364e')), 'Ontvangers')).length : '0',''].join('');

  return vContent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sms/components/f154e876b92a417abd28e66ca927d367/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var vOntvangers_extern, vOntvangers_intern, j, vOntvangers_intern_temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vOntvangers_extern = [];
  vOntvangers_intern = [];
  vOntvangers_intern_temp = [];
  var j_list = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('431b4a0671b9656e6365c34825ecab24')), 'Ontvangers'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'type')).toUpperCase() == 'INTERN') {
      if (!(vOntvangers_intern_temp.includes((getObjectProperty(j, 'Naam'))))) {
        addItemToList(vOntvangers_intern_temp, (getObjectProperty(j, 'Naam')));
        addItemToList(vOntvangers_intern, ({ [`Naam`]: (getObjectProperty(j, 'Naam')),[`TelefoonNummer`]: (getObjectProperty(j, 'TelefoonNummer')),[`Organisatie`]: 'STI' }));
      }
    } else {
      addItemToList(vOntvangers_extern, j);
    }
  }
  if (false) {
    addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Arlette van Bezu',[`EmailAdres`]: 'Arlette.van.Bezu@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '628646561',[`TelefoonNummerCompleet`]: '+31628646561',[`type`]: 'Intern' }));
    addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Daan Lenderink',[`EmailAdres`]: 'Daan.Lenderink@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '651490911',[`TelefoonNummerCompleet`]: '+31651490911',[`type`]: 'Intern' }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('8ef8dce7a9f30a8e3f4609a93becd409', ({ [`Ontvangers`]: vOntvangers_extern }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/c5cf9d9cf489d48a40ff0763e9c588ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vAPI_method, vAPI_url;


  console.log((await BackendlessUI.Functions.Custom['fn_449e5c08b074bfa98c39b2b63f75661e']('users', null)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/9ab37dfd8203f00ab28e24d7d765d9c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://schipholtravel.okta-emea.com/home/schipholtravel_smstool_1/0oabgdk1qvGiK1T6w0i7/alnbgdnhjferGl8BX0i7', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/ee2ff9e250bf2c33a3d1366b69560005/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'Organisatie',[`headerName`]: 'Organisatie',[`flex`]: 1 }), ({ [`field`]: 'Naam',[`headerName`]: 'Naam',[`flex`]: 1 }), ({ [`field`]: 'TelefoonNummer',[`headerName`]: 'TelefoonNummer',[`flex`]: 1 }), ({ [`field`]: 'type',[`headerName`]: 'Type',[`flex`]: 1 })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/sms/components/7f02addf0dae79f1a3ed904404037d71/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'Organisatie',[`headerName`]: 'Organisatie',[`flex`]: 1 }), ({ [`field`]: 'Naam',[`headerName`]: 'Naam',[`flex`]: 1 }), ({ [`field`]: 'TelefoonNummer',[`headerName`]: 'TelefoonNummer',[`flex`]: 1 })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/sms/components/ca8a9332223e86ff26f2c0ec1a1487e8/bundle.js', [], () => ({
  /* content */
  /* handler:leftListItemsLogic */
  ['leftListItemsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('431b4a0671b9656e6365c34825ecab24'), 'Concerns2'))

  },
  /* handler:leftListItemsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var vOntvangers_extern, vOntvangers_intern, j, vOntvangers_intern_temp, vSelection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vOntvangers_extern = [];
  vOntvangers_intern = [];
  vOntvangers_intern_temp = [];
  var vSelection_list = ___arguments['rightItems'];
  for (var vSelection_index in vSelection_list) {
    vSelection = vSelection_list[vSelection_index];
    var j_list = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('431b4a0671b9656e6365c34825ecab24')), 'Ontvangers'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'Organisatie')) == (getObjectProperty(vSelection, 'value'))) {
        if ((getObjectProperty(j, 'type')).toUpperCase() == 'INTERN') {
          if (!(vOntvangers_intern_temp.includes((getObjectProperty(j, 'Naam'))))) {
            addItemToList(vOntvangers_intern_temp, (getObjectProperty(j, 'Naam')));
            addItemToList(vOntvangers_intern, ({ [`Naam`]: (getObjectProperty(j, 'Naam')),[`TelefoonNummer`]: (getObjectProperty(j, 'TelefoonNummer')),[`Organisatie`]: 'STI' }));
          }
        } else {
          addItemToList(vOntvangers_extern, j);
        }
      }
    }
  }
  if (false) {
    addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Arlette van Bezu',[`EmailAdres`]: 'Arlette.van.Bezu@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '628646561',[`TelefoonNummerCompleet`]: '+31628646561',[`type`]: 'Intern' }));
    addItemToList(vOntvangers_intern, ({ [`Naam`]: 'Daan Lenderink',[`EmailAdres`]: 'Daan.Lenderink@Schipholtravel.com',[`Organisatie`]: 'STI',[`LandCode`]: '+31',[`TelefoonNummer`]: '651490911',[`TelefoonNummerCompleet`]: '+31651490911',[`type`]: 'Intern' }));
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('8ef8dce7a9f30a8e3f4609a93becd409', ({ [`Ontvangers`]: vOntvangers_extern }));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('736fb6ff1ea1b07a8ed39fb96833f6ca', ({ [`Ontvangers`]: vOntvangers_intern }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sms/components/a1861b56c50d2c2dfafaf52f576d0f16/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`field`]: 'Organisatie',[`headerName`]: 'Organisatie',[`flex`]: 1 }), ({ [`field`]: 'Naam',[`headerName`]: 'Naam',[`flex`]: 1 }), ({ [`field`]: 'TelefoonNummer',[`headerName`]: 'TelefoonNummer',[`flex`]: 1 })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/sms/components/9618bbdcddcf6f69654734a3fe7504e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var vcharlen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  vcharlen = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'message')) ? getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e28397fdd938e5164a56cbbbad55673'), 'message'))) : 0;

  return (String(vcharlen) + String(' / 150 characters used.'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sms/components/1443e58a61788ff87177acfa4fcd5dee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vBalance;


  console.log((await BackendlessUI.Functions.Custom['fn_66456c1bfba92f950d9aac0f74875cd1'](1, ___arguments.context.getComponentDataStoreByUid('154885f560136dba1a487cb31da94f84'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/bc7368c8792ee494e191df28b0b396f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://schipholtravel.okta-emea.com/home/schipholtravel_smstool_1/0oabgdk1qvGiK1T6w0i7/alnbgdnhjferGl8BX0i7', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/3b7ad92b5c5e5f1ac3dace94f631e78a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('1ced5d2421b1236c10ea90ab70110a96')), 'sms_balance')), 'credits'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sms/components/fa3631ecff2aa9f26389a294dbc9d55f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('1ced5d2421b1236c10ea90ab70110a96', (await BackendlessUI.Functions.Custom['fn_00b853dcb41c779afdcc105ef59fa241']()));
  await new Promise(r => setTimeout(r, 100 || 0));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sms/components/8dcebc7c09bc14aed712542d3b1cf419/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('154885f560136dba1a487cb31da94f84'), 'sendlist')).length)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/suminvoice_sdaksa903239aksjks02mdmsye27552js8a0233/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var vCount, vTotal, vFile, j, k, vFiles, vFilter, vEmail, vUserInfo, vReferer, vAllowRef;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vReferer = (await (async function() {
  	return document.referrer;
  })());
  vUserInfo = (await Backendless.Request.post(`${Backendless.appPath}/services/get_user_info/get_ip2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://ipapi.co/json/')).setEncoding('utf8').send()))));
  vEmail = (getObjectProperty(___arguments.context.pageData, 'email'));
  vAllowRef = ['https://robeco.schiphol.travel/', 'https://my.schiphol.travel/', null];
  if ((vAllowRef.includes(vReferer)) || (getObjectProperty(vUserInfo, 'isSTI')) == 1) {
    if (!vEmail) {
      if (vReferer == 'https://robeco.schiphol.travel/') {
        vEmail = 'robeco@schipholtravel.com';
      }
    }
    if (vEmail) {
      if (!(await Backendless.UserService.isValidLogin())) {
        await Backendless.UserService.loginAsGuest(false);
      }
      vCount = (await Backendless.Data.of('SumInvoice').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',vEmail,'\''].join(''))).setPageSize(10)));
      if (vCount.length > 0) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fcd9d311f1f922f0c62d954bc390c8c', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1638125541af28ee605f09be50816be2', true);
        vFilter = null;
        for (var j_index in vCount) {
          j = vCount[j_index];
          if (!vFilter) {
            vFilter = ['Concern IN (\'',(getObjectProperty(j, 'name')),'\''].join('');
          } else {
            vFilter = [vFilter,', \'',(getObjectProperty(j, 'name')),'\''].join('');
          }
        }
        vFilter = [vFilter,')',''].join('');
        vFiles = (await Backendless.Data.of('SumInvoice_files').find(Backendless.DataQueryBuilder.create().setWhereClause(vFilter).setSortBy('created desc').setPageSize(100)));
        vTotal = [];
        vFile = [];
        for (var j_index2 in vCount) {
          j = vCount[j_index2];
          for (var k_index in vFiles) {
            k = vFiles[k_index];
            if ((getObjectProperty(j, 'name')).toUpperCase() == (getObjectProperty(k, 'Concern')).toUpperCase()) {
              addItemToList(vFile, k);
            }
          }
          addItemToList(vTotal, ({ [`Concern`]: (getObjectProperty(j, 'name')),[`Files`]: vFile }));
          vFile = [];
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1638125541af28ee605f09be50816be2', vTotal);
      } else {
        console.log('No');
      }
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fcd9d311f1f922f0c62d954bc390c8c', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fcd9d311f1f922f0c62d954bc390c8c', true);
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/suminvoice_sdaksa903239aksjks02mdmsye27552js8a0233/components/b36c8af23b9b47884fb7102c08d62b47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://forms.schipholtravel.com/api/files/') + String(subsequenceFromStartLast((getObjectProperty(___arguments.context.dataModel, 'file')), 117))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/suminvoice_sdaksa903239aksjks02mdmsye27552js8a0233/components/e88d339d816d44b13dadb048db33a34a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'Files'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/suminvoice_upload/components/4f39765d1d174a87a50f70ea16579737/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
      await Backendless.UserService.loginAsGuest(false);
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['naming'] = ___arguments.files;

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      console.log(___arguments.error);
  if (await Backendless.UserService.isValidLogin()) {
    await Backendless.UserService.logout();
  }

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      if (await Backendless.UserService.isValidLogin()) {
    await Backendless.UserService.logout();
  }
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['file'] = ___arguments.uploadedFiles;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4f39765d1d174a87a50f70ea16579737');
  ___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318')['upload_button'] = 'Replace file';

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/suminvoice_upload/components/2cc2435c39865b63b89a8c5a5f66f3de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, i, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function data_check() {
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'Concern'))) {
    throw (new Error('Please select a concern'))
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file'))) {
    throw (new Error('Please select a file to upload'))
  }
}


  try {
    await data_check();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', true);
    list = [];
    i = 0;
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'file'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(list, ({ 'file': j,'file_name': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'naming')), i)), 'name')),'Concern': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f91ed7cfeb5666f83b635e4a10e63318'), 'Concern')) }));
      i = i + 1;
    }
    await Backendless.UserService.loginAsGuest(true);
    await Backendless.Data.of('SumInvoice_files').bulkCreate( list );
    if (await Backendless.UserService.isValidLogin()) {
      await Backendless.UserService.logout();
    }
    ___arguments.context.pageData['msg_status'] = 'File has been uploaded successfully!';
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4f39765d1d174a87a50f70ea16579737');
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f91ed7cfeb5666f83b635e4a10e63318');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb1413139a4fe63411ac0c34f572e892', true);

  } catch (error) {
    console.log(error);
    (function (message) { alert(message) })(error);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cc2435c39865b63b89a8c5a5f66f3de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26546e4b6dd7498ea3a64c7bd48be39c', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/suminvoice_upload/components/f91ed7cfeb5666f83b635e4a10e63318/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['file_orig'] = 'No file selected';
  ___arguments.context.dataModel['upload_button'] = 'Select file';

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/suminvoice_upload/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var vSTI;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  vSTI = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/get_user_info/get_ip2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://ipapi.co/json/')).setEncoding('utf8').send())))), 'isSTI'));
  if (vSTI == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', true);
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/suminvoice_upload/components/76ce00ec839bb119cc54b93f39c9df7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb1413139a4fe63411ac0c34f572e892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f91ed7cfeb5666f83b635e4a10e63318', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f91ed7cfeb5666f83b635e4a10e63318', ({ 'upload_button': 'Select file','file_orig': 'No file selected' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    
  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/test_umbrella/components/482a9db351860c3129d81885b0256aca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.value);
  if (___arguments.value == 'test1') {
    ___arguments.context.pageData['profile'] = ({ [`meta`]: ({ [`resourceType`]: 'User' }),[`name`]: ({ [`gender`]: 'Mr',[`givenName`]: 'John',[`familyName`]: 'Doe' }),[`active`]: 'True',[`emails`]: [({ [`type`]: 'work',[`value`]: 'john.doe@test.com',[`primary`]: true })],[`schemas`]: ['urn:ietf:params:scim:schemas:core:2.0:User', 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'],[`userName`]: 'john.doe@test.com',[`externalId`]: '00u7cpqhftSHAiOMj417',[`urn:ietf:params:scim:schemas:extension:enterprise:2.0:User`]: ({ [`manager`]: ({ [`value`]: 'Nicola Garrood' }),[`costCenter`]: '342  Compliance',[`organization`]: 'OPTIVER SERVICES BV',[`uuid`]: '74922077-dc00-4484-9387-a4e5f0424459',[`employeeNumber`]: '200849' }) });
  }
  if (___arguments.value == 'test2') {
    ___arguments.context.pageData['profile'] = ({ [`meta`]: ({ [`resourceType`]: 'User' }),[`name`]: ({ [`gender`]: 'Mrs',[`givenName`]: 'Jane',[`familyName`]: 'Doe' }),[`active`]: 'True',[`emails`]: [({ [`type`]: 'work',[`value`]: 'jane.doe@test.com',[`primary`]: true })],[`schemas`]: ['urn:ietf:params:scim:schemas:core:2.0:User', 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'],[`userName`]: 'jane.doe@test.com',[`externalId`]: '00u7cpqhftSHAiOMj417',[`urn:ietf:params:scim:schemas:extension:enterprise:2.0:User`]: ({ [`manager`]: ({ [`value`]: 'Rick Ruiter' }),[`costCenter`]: '300  Finance',[`organization`]: 'OPTIVER HOLDING',[`uuid`]: '5427cdd6-a959-4539-a400-141471cf890d',[`employeeNumber`]: '123846' }) });
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'profile'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/test_umbrella/components/125ed44dce816235443d800a3d17a9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, vResponses, vResult, vprofile_uuid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    console.log({ [`c`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')),[`q`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')),[`s`]: 1,[`filter`]: String('userName eq ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) });
    if (true) {
      vResponses = [];
      vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).query(({ [`c`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')),[`q`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')),[`s`]: 1,[`filter`]: String('userName eq ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) })).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
      console.log(vResult);
      addItemToList(vResponses, vResult);
      if (vResult.length == 0) {
        (function (message) { alert(message) })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) + String(' does not exist yet. Profile will be created.')));
        vResult = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send((getObjectProperty(___arguments.context.pageData, 'profile'))));
        console.log(vResult);
        addItemToList(vResponses, vResult);
      } else if (vResult.length == 1) {
        console.log(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'profile'))));
        (function (message) { alert(message) })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) + String(' does exist. Profile will be updated.')));
        vprofile_uuid = (getObjectProperty((getObjectProperty(vResult, '0')), 'uuid'));
        vResult = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users/') + String(vprofile_uuid)))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send((getObjectProperty(___arguments.context.pageData, 'profile'))));
        console.log(vResult);
        addItemToList(vResponses, vResult);
      }
      ___arguments.context.pageData['Responses'] = vResponses;
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_umbrella/components/e8e6632cea3628fe716a9a09bc6b5702/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, vResponses, vResult, vprofile_uuid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    console.log({ [`c`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')),[`q`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')),[`s`]: 1,[`filter`]: String('userName eq ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) });
    if (true) {
      vResponses = [];
      vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).query(({ [`c`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')),[`q`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')),[`s`]: 1,[`filter`]: String('userName eq ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) })).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
      console.log(vResult);
      addItemToList(vResponses, vResult);
      if (vResult.length == 0) {
        (function (message) { alert(message) })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) + String(' does not exist.')));
      } else if (vResult.length == 1) {
        (function (message) { alert(message) })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userName')) + String(' does exist. Profile will be deleted.')));
        vprofile_uuid = (getObjectProperty((getObjectProperty(vResult, '0')), 'uuid'));
        vResult = (await Backendless.Request['delete']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users/') + String(vprofile_uuid)))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
        console.log(vResult);
        addItemToList(vResponses, vResult);
      }
    }
    ___arguments.context.pageData['Responses'] = vResponses;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_umbrella/components/4f5dabb1e9fe642642645c0bdfc878ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_umbrella/components/e40f105a2a4553c1c3f7c81a95dd95da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (JSON.stringify(___arguments.context.dataModel))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/test_umbrella/components/bce19ab1d47f1fa4a5b7ad8449e9550c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vResponses, vProfilesToProcess, vResult, j, vprofile_uuid, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  vProfilesToProcess = [];
  if (!(getObjectProperty(___arguments.context.pageData, 'Profiles2'))) {
    for (i = 1; i <= 500; i++) {
      addItemToList(vProfilesToProcess, ({ [`meta`]: ({ [`resourceType`]: 'User' }),[`name`]: ({ [`gender`]: 'Mr',[`givenName`]: 'John',[`familyName`]: 'Doe' }),[`active`]: true,[`emails`]: [({ [`type`]: 'work',[`value`]: [i,'_','john.doe@test.com'].join(''),[`primary`]: true })],[`schemas`]: ['urn:ietf:params:scim:schemas:core:2.0:User', 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User'],[`userName`]: [i,'_','john.doe@test.com'].join(''),[`externalId`]: '00u7cpqhftSHAiOMj417',[`urn:ietf:params:scim:schemas:extension:enterprise:2.0:User`]: ({ [`manager`]: ({ [`value`]: 'Nicola Garrood' }),[`costCenter`]: '342  Compliance',[`organization`]: 'Test Company A',[`uuid`]: 'd0a4fd3a-771f-4b1c-acb3-cecdd37bc59a',[`employeeNumber`]: '200849' }),[`responses`]: [] }));
    }
    ___arguments.context.pageData['Profiles2'] = vProfilesToProcess;
  } else {
    vProfilesToProcess = (getObjectProperty(___arguments.context.pageData, 'Profiles2'));
  }
  console.log(vProfilesToProcess);
  vResponses = [];
  for (var j_index in vProfilesToProcess) {
    j = vProfilesToProcess[j_index];
    if (getObjectProperty(j, 'id')) {
      vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://airmessage.schipholtravel.com/api/scim/v3/','C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8','/Users/',(getObjectProperty(j, 'id'))].join('')))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
    } else {
      vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).query(({ [`c`]: (getObjectProperty((getObjectProperty(j, 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')),[`q`]: (getObjectProperty(j, 'userName')),[`s`]: 1,[`filter`]: String('userName eq ') + String(getObjectProperty(j, 'userName')) })).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
    }
    addItemToList((getObjectProperty(j, 'responses')), vResult);
    addItemToList(vResponses, vResult);
    vprofile_uuid = null;
    if (vResult.length == 0) {
      addItemToList((getObjectProperty(j, 'responses')), ({ [`result`]: 'No user found' }));
      addItemToList(vResponses, ({ [`result`]: 'No user found' }));
      vResult = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send(j));
    } else {
      if (getObjectProperty(vResult, 'id')) {
        vprofile_uuid = (getObjectProperty(vResult, 'id'));
      } else {
        vprofile_uuid = (getObjectProperty((getObjectProperty(vResult, '0')), 'uuid'));
      }
      j['id'] = vprofile_uuid;
      vResult = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users/') + String(vprofile_uuid)))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send(j));
    }
    addItemToList((getObjectProperty(j, 'responses')), vResult);
    addItemToList(vResponses, vResult);
  }
  console.log(vProfilesToProcess);
  console.log(vResponses);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_umbrella/components/3818faacd3e214396b5f3be4df1eaed6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vResult;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://airmessage.schipholtravel.com/api/scim/v3/','C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8','/Users/',(getObjectProperty(___arguments.context.pageData, 'uuid_manual')) ? (getObjectProperty(___arguments.context.pageData, 'uuid_manual')) : 'c9f16012-4d7a-4074-8427-b355e85e60a9'].join('')))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
  console.log(vResult);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/test_umbrella/components/8d2b717f337a2b6ff29e579168ab5891/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'profile')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'uuid')) : null)

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/test_umbrella/components/8e4589059971226ea77faf7c1c19fe64/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'profile')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'organization')) : null)

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/test_umbrella/components/3196fa1b61dfb8165e0f38aacb06c654/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'profile')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), 'costCenter')) : null)

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Object.assign((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'urn:ietf:params:scim:schemas:extension:enterprise:2.0:User')), ({ [`costCenter`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/test_umbrella/components/594f79241a840c096789a8924cea71bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vResponses, error, vResult, vprofile_uuid, vprofile, j, vData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(await Backendless.UserService.isValidLogin())) {
    await Backendless.UserService.loginAsGuest(true);
  }
  vData = (await Backendless.Data.of('scim').find(Backendless.DataQueryBuilder.create().setSortBy('created desc').setPageSize(1)));
  vResponses = [];
  console.log(vData);
  for (var j_index in vData) {
    j = vData[j_index];
    vprofile = (getObjectProperty(j, 'data'));
    if (true) {
      try {
        console.log({ [`filter`]: (getObjectProperty(vprofile, 'userName')) });
        if (true) {
          vResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).query(({ [`filter`]: (getObjectProperty(vprofile, 'userName')) })).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send());
          addItemToList(vResponses, vResult);
          if (vResult.length == 0) {
            vResult = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users')).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send(vprofile));
            addItemToList(vResponses, vResult);
          } else if (vResult.length == 1) {
            vprofile_uuid = (getObjectProperty((getObjectProperty(vResult, '0')), 'uuid'));
            vResult = (await Backendless.Request['put']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://airmessage.schipholtravel.com/api/scim/v3/C60E1D0A-44EF-42FA-A05C-FC7F14D5F4C8/Users/') + String(vprofile_uuid)))).set(({ [`Authorization`]: 'Basic eWJQWlBmbENsSURGOm5Wc2NLWlRDb05ZZQ==' })).setEncoding('utf8').send(vprofile));
            addItemToList(vResponses, vResult);
          }
        }

      } catch (error) {
        console.log(error);

      }
    }
  }
  console.log(vResponses);

  },
  /* handler:onClick */
  /* content */
}))

